import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class LeadWebsocketService {
  private socket: WebSocket;
  public newLeads: number = 0;

  private countryCodeMap: { [key: string]: string } = {
    Tunisia: 'TN',
    Senegal: 'SN',
    'Ivory-Coast': 'CI',
    Morocco: 'MA',
  };

  connect() {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) return;

    // this.socket = new WebSocket('ws://localhost:8083/ws/leads');
   
    const baseSocketUrl = environment.BACK_LEADS_SERVICE.replace('/api/v1', '');
    this.socket = new WebSocket(`${baseSocketUrl.replace('http', 'ws')}/ws/leads`);
  
    this.socket.onopen = () => {
      console.log('WebSocket connected');
      this.sendFilters(); // Send filters once on connection open
    };

    this.socket.onmessage = (event) => {
      const message = event.data;

      if (message.includes("Total leads count based on filters:")) {
        const leadCount = parseInt(message.split(': ')[1], 10);
        if (!isNaN(leadCount)) {
          this.newLeads = leadCount;
          console.log('Lead count updated:', this.newLeads);
        }
      }
    };

    this.socket.onerror = (error) => {
      console.error('WebSocket error:', error);
    };

    this.socket.onclose = () => {
      console.warn('WebSocket closed');
    };
  }

  close() {
    if (this.socket) {
      this.socket.close();
    }
  }

  private sendFilters() {
    const selectedCountries = JSON.parse(sessionStorage.getItem('selectedCountries') || '[]');
    const selectedCountryCodes = selectedCountries
      .map((country: string) => this.countryCodeMap[country])
      .filter(code => !!code); // filter out undefined

    const selectedStatuses = JSON.parse(sessionStorage.getItem('selectedStatuses') || '[]');
     // If "NEW" status exists, also add "PENDING_CONFIRMATION"
     if (selectedStatuses.includes("NEW") && !selectedStatuses.includes("PENDING_CONFIRMATION")) {
      selectedStatuses.push("PENDING_CONFIRMATION");
    }
    const selectedCompanyIds = JSON.parse(sessionStorage.getItem('selectedCompanies') || '[]');
    const companyIdsFromTheList = selectedCompanyIds.map((company: any) => company.id);
    const daysRangeToBackend = sessionStorage.getItem('daysAgo')
      ? Number(sessionStorage.getItem('daysAgo'))
      : null;

    const filters = {
      countries: selectedCountryCodes,
      statuses: selectedStatuses,
      companyIds: companyIdsFromTheList,
      daysAgo: daysRangeToBackend
    };

    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(filters));
      console.log('Filters sent to quarkus socket :', filters);
    }
  }
}
